// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"134":"ae5c76d9","163":"a6d7c467","259":"19f89c56","293":"7137a2bf","391":"b2a70bbb","461":"e866703d","787":"32085a93","842":"c6bdfb37","984":"b00c03b3"}[chunkId] + ".chunk.js";
};